var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 6.66667H15.8332V2.5M15.5916 13.6308C14.8153 14.8267 13.6761 15.7423 12.3411 16.243C11.0062 16.7438 9.54585 16.8034 8.17455 16.413C6.80325 16.0227 5.5932 15.203 4.72208 14.0743C3.85095 12.9456 3.36462 11.5674 3.3345 10.1419C3.30437 8.71648 3.73204 7.31891 4.55471 6.15442C5.37738 4.98993 6.55171 4.11985 7.9053 3.67194C9.25889 3.22402 10.7204 3.22186 12.0753 3.66577C13.4302 4.10968 14.6071 4.97628 15.4332 6.13833",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload2);
export default __webpack_public_path__ + "static/media/reload-2.0edd5496dc349b9ca8a856286cf62c1e.svg";
export { ForwardRef as ReactComponent };